import React, { useState, useEffect, Fragment } from 'react';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import { gAPI_Response_Details, postAPI_Create_Question, putAPI_Delete_Question } from '../../../../../../constants/APIs';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import MessageResponse from '../../components/ResponseBlock/MessageResponse';
import LinkResponse from '../../components/ResponseBlock/LinkResponse';
import ImageCarouselResponse from '../../components/ResponseBlock/ImageCarouselResponse';
import ExampleResponse from '../../components/ResponseBlock/ExampleResponse';
import { Row, Collapse, Button } from 'reactstrap';
import QuestionOptionForm from './QuestionOptionForm';
import QuestionOption from './QuestionOption';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import { faPlus, faBan } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
function Question({
    propertyId,
    code,
    setId,
    loadResponse,
    QuestionId,
    Question,
    locale
}) {
    const [elem, setelem] = useState(null);
    const [isAddQuestionOption, setIsAddQuestionOption] = useState(false);
    const codeResponse = async () => {
        return await AxiosAPI({
            methed: 'get',
            url: `${gAPI_Response_Details}/?property_id=${propertyId}&group_id=${getGroupID()}&code=${code}&lang=${locale === 'en' ? 'en-US' : locale}`,
        })
            .then(res => {
                setelem(res.data);
            })
            .catch(err => {
                console.log(err);
            });
    };

    const DeleteQuestion = (id) => {
        console.log(id)
        let deleteData = {
            Deleter: 'Dashboard'
        }
        try {
            AxiosAPI({
                method: 'put',
                url: `${putAPI_Delete_Question}/${id}`,
                data: deleteData,
            })
                .then(() => {
                    loadResponse();
                });
        } catch (error) {
            console.error(error);
        }
    }

    const SaveRecommenderQuestionCode = () => {
        let postData = {
            GroupId: getGroupID(),
            PropertyId: propertyId,
            QuestionSetId: setId,
            Code: code,
            DisplayOrder: 1,
            Status: 'Active',
            Creator: "API"
        };

        AxiosAPI({
            method: 'post',
            url: `${postAPI_Create_Question}`,
            data: postData,
        })
            .then(() => {
                console.log("added")
            })
            .finally(
                setTimeout(() => {
                    loadResponse();
                }, 1000)
            );
    }


    useEffect(() => {
        codeResponse();
    }, [code]);

    const CancelQuestionOption = () => {
        setIsAddQuestionOption(false)
    }

    const generator = () => {

        if (elem) {
            switch (elem.response.type) {
                case 'example':
                    return (
                        <Fragment>
                            <ExampleResponse
                                elem={{ ...elem }}
                                child={1}
                                SaveRecommenderQuestionCode={SaveRecommenderQuestionCode}
                            />
                        </Fragment>
                    );

                case 'messages':
                    return (
                        <Fragment>
                            <MessageResponse
                                elem={{ ...elem }}
                                child={1}
                                SaveRecommenderQuestionCode={SaveRecommenderQuestionCode}
                                DeleteQuestion={DeleteQuestion}
                                QuestionId={QuestionId}
                            />
                        </Fragment>
                    );

                case 'messages-link':
                    return (
                        <Fragment>
                            <LinkResponse
                                elem={{ ...elem }}
                                child={1}
                                SaveRecommenderQuestionCode={SaveRecommenderQuestionCode}
                                DeleteQuestion={DeleteQuestion}
                                QuestionId={QuestionId}
                            />
                        </Fragment>
                    );

                case 'messages-image-carousel':
                    return (
                        <Fragment>
                            <ImageCarouselResponse
                                elem={{ ...elem }}
                                child={1}
                                SaveRecommenderQuestionCode={SaveRecommenderQuestionCode}
                                DeleteQuestion={DeleteQuestion}
                                QuestionId={QuestionId}
                            />
                        </Fragment>
                    );

                default:
                    break;
            }

        } else return null;
    };
    return (
        <Fragment>
            {generator()}
            {QuestionId !== undefined && (
                <Fragment>
                    <Row>
                        <Colxx xs="12" sm="2" md="2" lg="2" className="mb-4">
                            <div
                                onClick={() => {
                                    setIsAddQuestionOption(true);
                                }}
                            >
                                <Button
                                    color="primary"
                                    className="add-button"
                                    size="xs"
                                    style={{ width: '100%' }}
                                >
                                    <FontAwesomeIcon icon={faPlus} />
                                    <span> </span>
                        Add Option
                    </Button> </div>
                        </Colxx>
                    </Row>
                    <Collapse isOpen={isAddQuestionOption}>
                        <Colxx xxs="4" className="mb-2 p-4" style={{ border: 'solid 1px #4556ac' }}>
                            <QuestionOptionForm CancelQuestionOption={CancelQuestionOption} QuestionId={QuestionId}
                                loadResponse={loadResponse}></QuestionOptionForm>
                        </Colxx>
                    </Collapse>
                </Fragment>)}
            <Row>
                <Colxx xs="12" sm="6" md="6" lg="6" className="mb-4">
                    <ul>
                        {Question !== undefined && Question.options !== null && Question.options.map((option, index) => {
                            return (
                                <li key={index}>

                                    <QuestionOption option={option} loadResponse={loadResponse} />

                                </li>
                            );
                        })}
                    </ul>
                </Colxx> </Row>
        </Fragment>
    );
}
const mapStateToProps = ({ settings }) => {
    const { propertyId, locale } = settings;
    return {
        propertyId, locale
    };
};
export default injectIntl(connect(mapStateToProps)(Question));